import { Nilable } from "@shared/utils";

export interface ICategoriaFiltroDTO {
    id: number;
    name: string;
}

export class CategoriaFiltroDTO {
    public id = 0;
    public nombre = "";

    constructor(json: Nilable<Partial<ICategoriaFiltroDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ICategoriaFiltroDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
    }

    public toJSON(): ICategoriaFiltroDTO {
        return {
            id: this.id,
            name: this.nombre
        };
    }
}
